import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/get-free-estimate-thank-you")({
  beforeLoad: () => {
    throw redirect({ to: "/contact", statusCode: 301 });
  },
});
